const ease = [0.165, 0.84, 0.44, 1]

const animations = {
  icon: {
    hidden: {
      opacity: 0,
      scale: 0,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        delay: 0.25,
        ease,
      },
    },
  },
  heading: {
    hidden: {
      opacity: 0,
      x: -60,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        ease,
        delay: 0.5,
        duration: 1,
      },
    },
  },
}

export default animations
